import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Emails from './Emails'
import { setAdminEmails } from 'components/QuestionnaireRequest/Property/store/slice'

const PropertySettingTabProcessor = (props) => {
  const dispatch = useDispatch()
  const { adminEmails } = useSelector((state) => state.buildingQuestionnaireAdmin)

  return (
    <div style={{ width: 900 }}>
      <div className="questionnaire-admin-general-table-container">
        <Emails
          buildingId={props.building.id}
          adminEmails={adminEmails}
          updateAdminEmails={(adminEmails) => dispatch(setAdminEmails(adminEmails))}
        />
      </div>
    </div>
  )
}
export default PropertySettingTabProcessor
